export default __webpack_public_path__ + "static/media/logo_un_lugar_como_el_hogar.11d37a7c.webp";